var tipo_aprobacionComponent = /** @class */ (function () {
    function tipo_aprobacionComponent() {
        this.rows = [];
        this.aprobacion = { "obra_nueva": false, "ampliacionmayor100m": false, "alteracion": false, "reconstruccion": false };
        if (!JSON.parse(localStorage.getItem("tipo_aprobacion"))) {
            localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_aprobacion"));
            this.aprobacion = {
                "obra_nueva": this.rows[0] ? this.rows[0].aprobacion.obra_nueva : false,
                "ampliacionmayor100m": this.rows[0] ? this.rows[0].aprobacion.ampliacionmayor100m : false,
                "alteracion": this.rows[0] ? this.rows[0].aprobacion.alteracion : false,
                "reconstruccion": this.rows[0] ? this.rows[0].aprobacion.reconstruccion : false
            };
        }
    }
    tipo_aprobacionComponent.prototype.add_tipo_aprobacion = function () {
        localStorage.setItem("tipo_aprobacion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_aprobacion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            aprobacion: this.aprobacion
        });
        localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_aprobacion")));
    };
    tipo_aprobacionComponent.prototype.delete_tipo_aprobacion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_aprobacion", JSON.stringify(this.rows));
            }
        }
    };
    return tipo_aprobacionComponent;
}());
export { tipo_aprobacionComponent };
